import React from "react";
import "./Footer.css";
import { Col, Row } from "react-bootstrap";
import { MdMessage } from "react-icons/md";

const Footer = () => {
  // const email = "mog.helpdesk@lerros.de";
  const email = "";
  const subject = "GOPLAN HELP";
  const getconnect = (e) => {
    e.preventDefault();
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}
    &su=${encodeURIComponent(subject)}`;
    window.open(gmailUrl, "_blank");
    // console.log("heyyyy");
  };
  return (
    <>
      <div className="footer_main">
        <div className="footer_copywrite">
          © {new Date().getFullYear()} Your Company. All rights reserved and protected
        </div>
        <div className="footer_contact">
          <div className="footer_icon">
            <MdMessage />
          </div>
          <div className="contact_text" onClick={getconnect}>
            Contact us..
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
